import styled from 'styled-components'

import { Link } from '../Link'

export const ToastLink = styled(Link)`
  word-break: break-all;
  white-space: normal;
`
